module.exports = __webpack_public_path__ + "img/firstimage.jpg";